// Reveals .ic-reveal elements as they scroll into view.
// Content is visible by default; the hidden start state only applies once
// this script adds .ic-js, and never under prefers-reduced-motion (see CSS).
(() => {
  const root = document.documentElement;
  if (!('IntersectionObserver' in window)) return;

  root.classList.add('ic-js');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  const observeAll = (scope) => {
    for (const el of scope.querySelectorAll('.ic-reveal:not(.is-visible)')) {
      observer.observe(el);
    }
  };

  observeAll(document);

  // Re-scan when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', (event) => observeAll(event.target));
})();
